import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'Chơi trò chơi miễn phí online, không cần tải | Gamezop',
  desc: 'Chơi trò chơi miễn phí online, không cần tải trên Gamezop. Hơn 200 game online miễn phí để chơi, bao gồm hành động, phiêu lưu, arcade, giải đố, đua xe và nhiều trò khác. Chơi ngay!',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'Chơi trò chơi miễn phí online, không cần tải',
    body: {
      text: [
        `Chơi game online miễn phí trên Gamezop mà không cần tải xuống!
Chọn trò chơi yêu thích của bạn từ danh sách và bắt đầu chơi chỉ trong vài giây. Chúng tôi có hơn 200+ trò chơi miễn phí phổ biến thuộc các thể loại như hành động, phiêu lưu, arcade, giải đố, đua xe và nhiều thể loại khác. Dù bạn muốn chơi trên di động, PC hay iOS, Gamezop đều có những trò chơi hay nhất dành cho bạn!
`,
        `Nếu bạn cảm thấy chán, Gamezop mang đến vô số lựa chọn giải trí thú vị. Xây dựng phòng thủ để chống lại kẻ thù, bắn hạ mục tiêu hoặc nhảy qua chướng ngại vật. Hãy thử các trò chơi hấp dẫn như Kingdom Fight, City Cricket, Fruity Fiesta và nhiều hơn nữa! Trò chơi của chúng tôi phù hợp với mọi lứa tuổi, từ trẻ em, người lớn đến người cao tuổi.`,
        `Bạn không cần thiết bị đắt tiền để chơi. Trò chơi của chúng tôi hoạt động mà không cần tải xuống hay cài đặt – chỉ cần trình duyệt và kết nối internet. Bạn có thể chơi trên máy tính để bàn, máy tính xách tay, Chromebook, điện thoại thông minh, máy tính bảng và nhiều thiết bị khác. `,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: 'Những trò chơi trực tuyến miễn phí nào là hay nhất?',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Những game online miễn phí nào có thể chơi cùng bạn bè?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Thể loại game online phổ biến nào được yêu thích nhất?',
    body: {
      text: [],
      list: [
        {
          name: 'Trò chơi điên cuồng',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'Trò chơi cờ bàn',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'Trò chơi phiêu lưu',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'Trò chơi giải đố',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'Trò chơi bắn súng',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Gamezop là gì?',
    body: {
      text: [
        `Gamezop là nền tảng trò chơi plăg-an-plây, cho phép các ứng dụng và trang web dễ dàng tích hợp trò chơi giải trí, từ đó tăng cường tương tác người dùng một cách hiệu quả. Bên cạnh trò chơi, Gamezop còn vận hành nhiều nền tảng chuyên biệt khác: Quizzop dành cho các câu đố tương tác, Astrozop cung cấp dự đoán và thông tin chiêm tinh, Criczop cập nhật tỉ số và tin tức trực tiếp về cricket, và Feedzop tổng hợp tin tức chọn lọc. Tất cả các nền tảng này cùng nhau tạo nên một bộ giải pháp nội dung đa dạng, đáp ứng sở thích của nhiều đối tượng người dùng khác nhau.`,
        `Với hơn 8.000 tích hợp trên 70 quốc gia, Gamezop và các nền tảng liên kết của mình đã được tin dùng bởi các thương hiệu lớn như Amazon, Samsung Internet, Snap, Tata Play, AccuWeather và Paytm. Các giải pháp này không chỉ thúc đẩy tương tác người dùng mà còn mở ra cơ hội doanh thu từ quảng cáo. Quá trình tích hợp diễn ra nhanh chóng, chỉ mất 30 phút, giúp ứng dụng và trang web dễ dàng cung cấp nội dung hấp dẫn bao gồm trò chơi, câu đố, chiêm tinh, cricket và tin tức.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'Câu Hỏi Thường Gặp',
  faqs: [
    {
      tag: 'h3',
      title: 'Tôi có thể chơi trò chơi miễn phí mà không cần tải xuống hoặc cài đặt không?',
      body: ['Có, bạn có thể chơi trò chơi miễn phí mà không cần tải xuống hoặc cài đặt chúng.'],
    },
    {
      tag: 'h3',
      title: 'Tôi có cần đăng ký tài khoản để chơi không?',
      body: [
        'Không, bạn không cần đăng ký tài khoản để chơi trò chơi trên Gamezop.com. Bạn có thể bắt đầu chơi ngay lập tức mà không cần đăng ký.',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/vi',
      },
    },
    {
      tag: 'h3',
      title: 'Chơi game online có an toàn không?',
      body: [
        'Có, việc chơi game online trên các nền tảng đáng tin cậy như Gamezop là an toàn. Các trò chơi của chúng tôi không yêu cầu tải xuống, giảm thiểu rủi ro về phần mềm độc hại. Chúng tôi chú trọng đến bảo mật người dùng và đảm bảo trải nghiệm chơi game an toàn mà không ảnh hưởng đến quyền riêng tư hoặc an toàn thiết bị của bạn.',
      ],
    },
    {
      tag: 'h3',
      title: 'Trò chơi miễn phí có thực sự miễn phí không?',
      body: [
        'Đúng vậy, các trò chơi miễn phí trên Gamezop thực sự miễn phí để chơi. Tuy nhiên, những trò chơi này có thể hiển thị quảng cáo để hỗ trợ nền tảng.',
      ],
    },
    {
      tag: 'h3',
      title: 'Có trò chơi miễn phí nào dành cho người cao tuổi không?',
      body: [
        'Có, chúng tôi có các trò chơi miễn phí phù hợp với người cao tuổi mà bạn có thể chơi trực tuyến, bao gồm Sudoku Classic, Solitaire Gold, Chess Grandmaster và nhiều trò chơi khác.',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
